// removed by extract-text-webpack-plugin
module.exports = {"flexAlign":"_8FATfBf-MNd4bKaVfASp5"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/FlexAlign/style.css
// module id = 417
// module chunks = 38